import React, {useState} from "react";
import {observer} from "mobx-react";
import {useRequiredStore} from "../../../../../utils/store";
import {AgentDataStoreContext} from "../../agent.data.store";
import {useTranslate} from "../../../../../hooks/translate.hook";
import {ComponentPropsFromRoute} from "../../../../../routers/routers";
import {Button, Col, Form, Row, Select, Typography} from "antd";
import {accountService} from "../../../../../services/accounts/account.service";
import {notifications} from "../../../../../services/notifications/notifications";

export const AgentDataPayments: React.FC<ComponentPropsFromRoute> = observer(({name}) => {
    const {account, loadData} = useRequiredStore(AgentDataStoreContext);
    const t = useTranslate();
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();

    if (!account) {
        return <></>;
    }

    const submit = async (values: any) => {
        setLoading(true)
        try {
            await accountService.updatePayments(account.id, values)
            await loadData()
            notifications.successfully()
        } catch (e: any) {
            if (e.response?.data.fields) {
                form.setFields(e.response?.data?.fields);
            }
        } finally {
            setLoading(false);
        }
    }

    const defaultValues = {
        allowPayments: account.allowPayments
    }

    console.log("DEF", defaultValues);

    return <Form
        size={"middle"}
        form={form}
        layout="vertical"
        initialValues={defaultValues}
        onFinish={async (values) => {
            await form.validateFields();
            await submit(values)
        }}
    >
        <Typography.Title level={3}>{t("CLIENT.PAYMENTS.TITLE")}</Typography.Title>
        <Row gutter={[30, 0]} align={"top"}>
            <Col span={24}>
                <Row gutter={[30, 0]} align={"top"}>
                    <Col span={6}>
                        <Form.Item
                            name="allowPayments"
                            label={t("BRANCH.ALLOW_PAYMENTS")}
                        >
                            <Select placeholder={t("BRANCH.ALLOW_PAYMENTS")} disabled={loading}>
                                <Select.Option value={true as any}>{t("ALLOW")}</Select.Option>
                                <Select.Option value={false as any}>{t("NOT_ALLOW")}</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[30, 0]} align={"top"}>
                    <Col span={24}>
                        <Button type={"primary"} onClick={() => form.submit()}>{t("SAVE")}</Button>
                    </Col>
                </Row>
            </Col>
        </Row>
    </Form>
});
